export const knowledgeBaseUrl = 'https://support.electric.ai/';

export const SAAS_APPLICATION_AUTOMATION_URL =
  'https://support.electric.ai/electricithub/electric-it-hub-saas-application-automation';
export const APPLICATIONS_URL =
  'https://support.electric.ai/electricithub/electric-it-hub-applications';
export const APPLICATIONS_MANAGEMENT_OPTIONS_URL = `${APPLICATIONS_URL}#Applications-ApplicationManagementOptions`;
export const MDM_SECURITY_URL =
  'https://support.electric.ai/electricithub/electric-it-hub-value-of-mdm';
export const SECURITY_POLICIES_URL =
  'https://support.electric.ai/electricithub/electric-it-hub-understanding-the-asset-device-pro';
export const REMOTE_LOCK_WIPE_URL =
  'https://support.electric.ai/electricithub/electric-it-hub-lock-unlock-devices';
export const ZERO_TOUCH_PROVISIONING_URL =
  'https://support.electric.ai/electricithub/electric-it-hub-utilizing-zero-touch-provisioning-';
export const PASSWORD_BREACHES_URL =
  'https://support.electric.ai/electricithub/electric-it-hub-password-breach-dashboard';

export const aiChatFeedbackFormUrl = 'https://forms.gle/W7vvrxaNGasrzxmk6';

export const BOOKING_URL =
  'https://app.apollo.io/#/meet/inbound-router/8ja-8ca-wmo';
export const JUSTWORKS_BOOKING_URL =
  'https://app.apollo.io/#/meet/inbound-router/pdj-q2x-yh3';
export const TRINET_BOOKING_URL =
  'https://app.apollo.io/#/meet/inbound-router/ncl-tbu-lne';
export const HR_FOUNDATION_BOOKING_URL =
  'https://app.apollo.io/#/meet/inbound-router/8ja-8ca-wmo';
export const ISOLVED_TIER_URL = 'https://electric.ai/isolved-tier';
export const ISOLVED_SEAT_URL = 'https://electric.ai/isolved-seat';

export const getElectrolyteBaseUrl = () => {
  return window._env_.VITE_AUTH0_CALLBACK_URL;
};
// The Microsoft Admin Center URL for approving a Reseller Relationship invitation
export const MICROSOFT_RESELLER_INVITATION_URL =
  'https://admin.microsoft.com/Adminportal/Home?invType=IndirectResellerRelationship&partnerId=fdb7507a-5aa4-4da6-9d82-ee3a6910c75b&msppId=5407728&indirectCSPId=ff1b2576-d461-4916-97dc-7ada1cd798dc#/BillingAccounts/partner-invitation';
